// constants/cardVideoThemes.js - Video Background Themes for Cards

export const CARD_VIDEO_THEMES = [
  {
    id: 'aurora-1',
    name: 'Aurora Borealis',
    videoUrl: 'https://cdn.pixabay.com/video/2023/04/26/159467-821931277_large.mp4',
    thumbnailUrl: 'https://cdn.pixabay.com/video/2023/04/26/159467-821931277_large.jpg',
    defaultColor: '#1a3a52',
  },
  {
    id: 'ocean-1',
    name: 'Ocean Waves',
    videoUrl: 'https://cdn.pixabay.com/video/2021/05/05/74286-546832526_large.mp4',
    thumbnailUrl: 'https://cdn.pixabay.com/video/2021/05/05/74286-546832526_large.jpg',
    defaultColor: '#0a5f7f',
  },
  {
    id: 'fire-1',
    name: 'Campfire',
    videoUrl: 'https://cdn.pixabay.com/video/2022/10/03/133874-758224085_large.mp4',
    thumbnailUrl: 'https://cdn.pixabay.com/video/2022/10/03/133874-758224085_large.jpg',
    defaultColor: '#8b4513',
  },
  {
    id: 'space-1',
    name: 'Starry Night',
    videoUrl: 'https://cdn.pixabay.com/video/2023/04/10/158234-816874956_large.mp4',
    thumbnailUrl: 'https://cdn.pixabay.com/video/2023/04/10/158234-816874956_large.jpg',
    defaultColor: '#0a0a1f',
  },
  {
    id: 'sunset-1',
    name: 'Golden Sunset',
    videoUrl: 'https://cdn.pixabay.com/video/2020/05/07/38737-417703963_large.mp4',
    thumbnailUrl: 'https://cdn.pixabay.com/video/2020/05/07/38737-417703963_large.jpg',
    defaultColor: '#ff6b35',
  },
  {
    id: 'rain-1',
    name: 'Rain Drops',
    videoUrl: 'https://cdn.pixabay.com/video/2021/07/07/80752-572945132_large.mp4',
    thumbnailUrl: 'https://cdn.pixabay.com/video/2021/07/07/80752-572945132_large.jpg',
    defaultColor: '#4a5568',
  },
  {
    id: 'clouds-1',
    name: 'Cloud Timelapse',
    videoUrl: 'https://cdn.pixabay.com/video/2022/02/25/109161-681734009_large.mp4',
    thumbnailUrl: 'https://cdn.pixabay.com/video/2022/02/25/109161-681734009_large.jpg',
    defaultColor: '#87ceeb',
  },
  {
    id: 'flowers-1',
    name: 'Blooming Flowers',
    videoUrl: 'https://cdn.pixabay.com/video/2022/09/17/131894-751953488_large.mp4',
    thumbnailUrl: 'https://cdn.pixabay.com/video/2022/09/17/131894-751953488_large.jpg',
    defaultColor: '#ff69b4',
  },
];

export const getVideoThemeById = (id) => {
  return CARD_VIDEO_THEMES.find(theme => theme.id === id);
};

export default CARD_VIDEO_THEMES;
